/**
 * Core Dashboard JS
 */
import Vue from 'vue';
import * as Sentry from '@sentry/browser';

window.Vue = Vue;

const SentryDSN = document.head.querySelector('meta[name="sentry-dsn"]').content;
if (!!SentryDSN) {
  Sentry.init({
    dsn: SentryDSN,
  });
}

// Instance Properties (Globals)
Vue.prototype.$kitsHost = document.head.querySelector('meta[name=kitsilano-host]').content;
